import React, { useEffect, useState } from 'react'

// Import Swiper React components
import { Scrollbar } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/scrollbar'

//Import JS breakpoints from HomeProducts.js
import { mobileMaxW } from './HomeProducts'
import { desktopMinW } from './HomeProducts'

const TilesSwiper2 = ({
  heading,
  id = '',
  SlideTiles,
  GridStyles = '',
  TileStyle = '',
  containerStyles = '',
}) => {
  const [breakpoint, setBreakpoint] = useState('')

  useEffect(() => {
    checkBreakpoint()
    window.addEventListener('resize', () => {
      checkBreakpoint()
    })
  })

  const checkBreakpoint = () => {
    const desktopBreakpoint = window.matchMedia(desktopMinW)
    const mobileBreakpoint = window.matchMedia(mobileMaxW)
    if (desktopBreakpoint.matches) {
      setBreakpoint('desktop')
    }
    if (mobileBreakpoint.matches) {
      setBreakpoint('mobile')
    }
    if (!mobileBreakpoint.matches && !desktopBreakpoint.matches) {
      setBreakpoint('tablet')
    }
  }

  return (
    <div
      id={id}
      className={`${containerStyles} md:pt-[65px] md:flex md:flex-col md:items-center md:text-center container bg-gray-100 pt-[50px] text-black-100`}
      data-aos='fade-up'
      data-aos-duration='300'
      data-aos-easing='ease-in-out'
    >
      <div className='max-w-[830px]'>
        <h2 className='md:text-5xl text-3xl pb-[40px]'>{heading}</h2>
      </div>
      {breakpoint === 'desktop' || breakpoint === 'tablet' ? (
        <div className={`hidden md:grid ${GridStyles}`}>
          {SlideTiles.map((tile, index) => {
            return (
              <div
                key={index}
                className={`${TileStyle} lg:px-[25px] bg-white py-[40px] px-[33px] flex flex-col items-center gap-[25px] overflow-hidden`}
                data-aos='fade-up'
                data-aos-duration='500'
                data-aos-easing='ease-in-out'
                data-aos-delay={index * 100}
              >
                {tile.icon}
                <p className='text-center'>{tile.content}</p>
              </div>
            )
          })}
        </div>
      ) : (
        <Swiper
          modules={[Scrollbar]}
          spaceBetween={25}
          slidesPerView={1.5}
          scrollbar={{
            draggable: true,
            dragSize: 100,
            hide: false,
          }}
          className='md:hidden'
        >
          {SlideTiles.map((tile, index) => {
            return (
              <SwiperSlide key={index} className='flex flex-col gap-[25px]'>
                {tile.icon}
                <p>{tile.content}</p>
              </SwiperSlide>
            )
          })}
        </Swiper>
      )}
    </div>
  )
}

export default TilesSwiper2
